import React from 'react'

import * as r from '../../../../react-utils'

import * as MuiIcons from '@mui/icons-material'

import * as cp from '../../../comps'

import { productVideoGroups } from './productVideoLinks'

//@ts-ignore
import styles from './ProductVideos.module.css'

export interface ProductVideosProps {
  company: string
}

export default React.memo<ProductVideosProps>(function ProductVideos({
  company,
}) {
  const [expandedVal, , expandedToggle] = r.useBool(true)

  return (
    <cp.PageReport
      autoHeight
      company={company}
      companyBorder
      hPad
      noPDF
      title="Smart Home Videos"
    >
      <div className={styles['toggle']} onClick={expandedToggle}>
        <span>{expandedVal ? 'Hide' : 'Show'} videos</span>
        <MuiIcons.ChevronRight
          className={
            expandedVal ? styles['chevron-expanded'] : styles['chevron']
          }
          fontSize="small"
        />
      </div>

      {expandedVal && (
        <div className={styles['groups']}>
          {productVideoGroups.map((group) => (
            <div className={styles['group']} key={group.title}>
              <span className={styles['group-title']}>{group.title}</span>

              <div className={styles['links']}>
                {group.videos.map((video) => (
                  <a
                    className={styles['link']}
                    href={video.url}
                    key={video.url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {video.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </cp.PageReport>
  )
})
